import { postAction } from './client';
import { currentSession, signOut } from '../auth/session';

type Row = Record<string, unknown>;

async function call<T>(action: string, payload: Record<string, unknown> = {}): Promise<T> {
  const ses = currentSession();
  if (!ses) throw new Error('Not signed in.');
  const res = await postAction<T & { ok: boolean; error?: string; message?: string }>(action, { ...payload, token: ses.token });
  if (!res.ok) {
    if (res.error === 'AUTH_REQUIRED' || res.error === 'AUTH_INVALID') signOut();
    throw new Error(res.message || res.error || 'Request failed');
  }
  return res;
}

export interface DashboardData {
  todayPmsCycleDay?: number;
  totals: { equipment: number; readingsToday: number; due: number; overdue: number; abnormalToday: number };
  equipment: Array<{
    equipmentId: string; name: string; location: string; category?: 'daily' | 'pms';
    pmsCycleDay?: number | null; pmsGroup?: string;
    lastReadingAt: string | null; nextRecommendedAt: string | null; status: string;
  }>;
}

export const operatorApi = {
  dashboard: () => call<{ ok: true } & DashboardData>('dashboard'),
  dailyLog: (equipmentId: string, date: string) =>
    call<{
      ok: true;
      equipment: Row | null;
      template: { sections: Array<{ key: string; label: string; fields: Array<{ key: string; label: string; unit: string }> }> };
      date: string;
      org?: { name: string; subtitle: string; letterheadUrl: string };
      rows: Row[];
    }>('dailyLog', { equipmentId, date }),
};
